import { SvgIcon, SvgIconProps } from "@mui/material";

export function AddDocumentIcon(props: SvgIconProps) {
  return (
    <SvgIcon {...props}>
      <path d="M11,18 L13,18 L13,15 L16,15 L16,13 L13,13 L13,10 L11,10 L11,13 L8,13 L8,15 L11,15 L11,18 Z M6,22 C5.45,22 4.97916667,21.8041667 4.5875,21.4125 C4.19583333,21.0208333 4,20.55 4,20 L4,4 C4,3.45 4.19583333,2.97916667 4.5875,2.5875 C4.97916667,2.19583333 5.45,2 6,2 L14,2 L20,8 L20,20 C20,20.55 19.8041667,21.0208333 19.4125,21.4125 C19.0208333,21.8041667 18.55,22 18,22 L6,22 Z M13,9 L13,4 L6,4 L6,20 L18,20 L18,9 L13,9 Z M6.0375,4 L6.0375,9 L6.0375,4 L6.0375,20 L6.0375,4 Z" />
    </SvgIcon>
  );
}
